/* eslint-disable no-undef */
import {
  GOLD_REPORT_ALL,
  GOLD_REPORT_GET,
  GOLD_REPORT_DEL,
  GOLD_REPORT_PUT,
  GOLD_REPORT_POST,
  GOLD_REPORT_LOADING,
  GOLD_REPORT_ERROR,
  GOLD_REPORT_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const goldReportCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_REPORT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/gold-report`,
      payload,
    );

    dispatch({ type: GOLD_REPORT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_REPORT_ERROR });
    throw new Error(error);
  }
};
export const goldReportAll =
  ({
    name = '',
    size = '',
    page = 1,
    place = '',
    statusPlace = '',
    startDate = '',
    endDate = '',
    date = '',
    month = '',
    year = '',
    all = false,
  }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GOLD_REPORT_RESET });
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/gold-report?name=${name}&size=${size}&page=${page}&place=${place}&statusPlace=${statusPlace}&all=${all}&startDate${startDate}&endDate${endDate}&date=${date}&month=${month}&year=${year}`,
      );
      if (status === 200) {
        dispatch({ type: GOLD_REPORT_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GOLD_REPORT_ERROR });
      throw new Error(error);
    }
  };

export const goldReportGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/gold-report/${id}`,
    );
    if (status === 200) {
      dispatch({ type: GOLD_REPORT_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_REPORT_ERROR });
    throw new Error(error);
  }
};

export const goldReportPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_REPORT_LOADING });
    // console.log('Payload', payload);
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/gold-report/${id}`,
      payload,
    );
    // console.log('data', data);
    dispatch({ type: GOLD_REPORT_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_REPORT_ERROR });
    throw new Error(error);
  }
};
export const goldReportDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_REPORT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/gold-report/${id}`,
    );
    dispatch({ type: GOLD_REPORT_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_REPORT_ERROR });
    console.error(error);
    throw new Error(error);
  }
};

export const goldReportReset = () => async (dispatch) => {
  try {
    dispatch({ type: GOLD_REPORT_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_REPORT_ERROR });
    throw new Error(error);
  }
};
